export default __webpack_public_path__ + "static/media/slider_inicio_5.94a67dae.jpg";